import { useAdminUpdate } from '@reapitform/hooks'
import { AdminReviewCardSection, AdminReviewCardSectionPayload } from '../types'

/** Creates a section under a review card (`POST /api/review-cards/{reviewCardRef}/sections`). */
export const useCreateAdminReviewCardSection = (reviewCardReferenceID: string) =>
  useAdminUpdate<AdminReviewCardSectionPayload, AdminReviewCardSection>({
    path: `/api/review-cards/${reviewCardReferenceID}/sections`,
    method: 'POST',
    errorMessage: 'Failed to create the section',
    successMessage: 'Section created',
  })
